import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { STATICS } from 'statics'
import { setStage } from 'slices/drawer'
import { NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { SignalInfo } from '../signal-info'
import { SignalStep } from '../signal-step'
import './style.scss'

export function ModemCableReconnect() {
  const dispatch = useDispatch()

  function handleNextClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.MODEM_ALMOST_DONE))
  }

  return (
    <div className='modem-cable-reconnect'>
      <SignalInfo
        icon={STATICS.MODEM_RESTART}
        iconAlt='Icone de modem reiniciando'
        title='Reconecte os cabos'
      >
        <SignalStep
          number={3}
          description='Agora você já pode conectar todos os cabos de volta no modem.'
        />
      </SignalInfo>
      <div className='actions-container'>
        <Button className='button-component -large' color='primary' onClick={handleNextClick}>
          Os cabos estão conectados
        </Button>
      </div>
    </div>
  )
}
